/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

import {
  pb, mr, px, mb, pt, mt, p, mx, pr, py
} from 'styled-components-spacing';

import breakpoint from 'styled-components-breakpoint';
import Grid from 'styled-components-grid';
import { styledButton } from '@styles/buttons';

import Checkbox from '@components/Checkbox';
import theme from '@theme';
import { CountryDropdown } from 'react-country-region-selector';
import { SvgWhatsapp } from '@images/svg';

const { borderRadius, colors } = theme;

export const StyledThanksTitle = styled.div`
  font-size: 40px;
  line-height: 2rem;
  font-weight: 700;
  color: ${colors.navyGray};
  width: 100%;
  text-align: center;
  ${mb(3)}
`;

export const StyledThanksSubtitle = styled.div`
  ${mb(4)}
  font-size: 1.25rem;
  line-height: 2rem;
  font-weight: 600;
  text-align: center;
  align-self: center;
  color: ${({ finderForm }) => (finderForm ? colors.darkBlue : colors.white)};
  ${breakpoint('desktop')`
    color: ${({ finderForm }) => (finderForm ? colors.white : colors.navyGray)};
  `}
`;

export const StyledThanksWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  color: ${colors.white};
  ${breakpoint('desktop')`
    color: ${colors.darkBlue};
  `}
`;

export const StyledHeadTitle = styled.span`
  ${mb(3)}
  color: ${colors.mediumGray};
  display: block;
  font-size: 18px;
  text-transform: uppercase;
  text-align: center;
  ${breakpoint('desktop')`
    font-size: 20px;
    text-align: right;
  `}
`;

export const StyledRegion = styled(CountryDropdown)`
  ${borderRadius.small}
  ${mt(2)}
  background-color: #fff !important;
  border: 0;
  height: 48px;
  padding-left: 1.5rem;
  padding-right: 12px;
  appearance: none;
  background-color: ${colors.greyBlue10};
  width: 100%;
  color: ${({ value }) => (value ? 'black' : 'grey')};
  font-size: 1rem;
  ${breakpoint('mobile', 'desktop')`
    background-color: ${colors.greyBlue10} !important;
  `}
  ${breakpoint('desktop')`
      padding-left: 0.75rem;
  `}
  &::-ms-expand {
    display: none;
  }
`;

export const StyledContactIconWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin-top: 16px;
`;

export const StyledDragDropBottomSection = styled.div`
  width: 90%;
  align-self: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 32px;
  padding-top: 16px;
  border-top: 2px solid ${colors.translucentDarkBlue};
`;

export const StyledDragDropBottomHeadline = styled.span`
  font-size: 22px;
  font-weight: 700;
  color: ${colors.navyGray};
`;

export const StyledCompletedMessage = styled.span`
  align-self: center;
`;

export const StyledCompletedWrapper = styled.div`
  width: 50%;
  align-self: center;
`;

export const StyledContactIconSvgContainer = styled.div`
  width: 50px;
  height: 50px;
  background-color: yellow;
`;

export const StyledHeadSubtitle = styled.p`
  ${mb(2.5)}
  ${theme.typography.Raleway}
  font-size: 24px;
  text-align: center;
  ${breakpoint('desktop')`
    text-align: right;
  `}
`;

export const StyledHeadWrapper = styled.div`
  ${pb(1)}
  ${pt(4.5)}
  width: 100%;
  ${breakpoint('desktop')`
  ${pt(0)}
`}
`;

export const StyledFormGrid = styled(Grid)`
  background-color: ${props => (props.treatmentFormName ? 'unset' : colors.white)};
  position: relative;
  input {
    background-color: ${props => (props.treatmentFormName ? colors.white : colors.lightGray)};
    border: ${props =>
    (props.treatmentFormName ? 'none' : `1px solid ${colors.translucentDarkBlue}`)};
  }
  input[type='tel'] {
    background-color: ${props =>
    (props.treatmentFormName ? colors.white : colors.lightGray)} !important;
    box-sizing: border-box !important;
    border: 1px solid ${colors.translucentDarkBlue};
    outline: none;
  }
  ${({ flowForm }) => (flowForm ? mx(2) : '')}
  ${breakpoint('mobile', 'desktop')`
    ${props => (props.treatmentFormName ? px(0) : px(3))}
    ${props => (props.treatmentFormName ? py(0) : py(3))}
    ${props => (props.treatmentFormName ? mb(0) : mb(3))}
    ${props => (props.treatmentFormName ? mt(0) : mt(3))}
    border-radius: 8px;
  `};
`;

export const StyledButtonSubmit = styled.button`
  ${styledButton}
  font-weight: bold;
  border-radius: 10px;
  width: ${props => (props.isModal || props.treatmentFormName ? '130px' : '150px')};
  align-self: center;
  background-color: ${props => (props.treatmentFormName ? colors.white : colors.newThemeDarkBlue)};
  color: ${props => (props.treatmentFormName ? colors.newThemeDarkBlue : colors.white)};
  border: none;
  outline: none;
  padding: ${props => (props.treatmentFormName || props.isModal) && '10px'};
`;

export const StyledButtondiv = styled.div`
  width: 100px;
  height: 50px;
  background-color: ${colors.newThemeDarkBlue};
  color: white;
`;

export const StyledButtonFinish = styled(StyledButtonSubmit)``;

export const StyledWhatsappIcon = styled(SvgWhatsapp)`
  ${mr(3)}
  height: 35px;
  width: 35px;
  @media(max-width: 650px){
    height: 30px;
    width: 30px;
  }
  @media(max-width: 450px){
    height: 25px;
    width: 25px;
    margin-right: 10px;
  }
`;

export const StyledConnectMessage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const StyledItem = styled(Grid.Unit)`
  ${mt(3)}
  ${pb(3)}
  ${props =>
    props.submitButton
    && `
    display: flex;
    justify-content: center;
  `}
  ${props => (props.treatmentFormName ? pb(0) : pb(2))}
  ${props => props.treatmentFormName && mb(2)}
  ${props => props.treatmentFormName && mt(2)}
`;

export const StyledRowCustomUnit = styled(Grid.Unit)`
  display: flex;
  flex-direction: row;
  ${pb(2)}
`;
export const StyledColumnCustomUnit = styled(Grid.Unit)`
  display: flex;
  flex-direction: row;
  &:first-child {
    ${pr(2)}
  }
  ${breakpoint('mobile', 'tablet')`
   &:first-child {
    ${mr(3)}
  } 
  `}
`;

export const StyledItemSpacing = styled(StyledItem)`
  ${pr(3.5)}
  ${pb(3)}
  font-size: 18px;
  line-height: 1.57;
  color: ${props => (props.treatmentFormName ? colors.white : colors.darkBlue)};
  ${breakpoint('desktop')`
    ${px(0)}
    color: ${colors.darkBlue};
    color: ${props => (props.treatmentFormName ? colors.white : colors.darkBlue)};
  `}
`;

export const StyledFillOut = styled(StyledItemSpacing)`
  ${props => (props.treatmentFormName ? pb(0) : pb(3))}
  font-weight: 700;
  margin-top: 0px;
  color: ${props => (props.treatmentFormName ? colors.white : colors.darkblue)};
  ${breakpoint('desktop')`
    text-align: center;
    font-size: ${props => (props.treatmentFormName ? '18px' : '22px')};
    line-height: 1.57;
    color: ${props => (props.treatmentFormName ? colors.white : colors.darkblue)};
    ${props => props.isModal && mt(1)}
  `}
`;

export const StyledCheckbox = styled(Checkbox)`
  ${mr(4)}
  padding: 2px;
  background-color: ${colors.lightGray};
  box-sizing: content-box !important;
  margin-top: 6px;
  height: 40px;
  width: 40px;
  border: 1px solid ${colors.translucentDarkBlue};
  div {
    background-color: ${colors.lightGray};
    height: 40px;
    width: 40px;
  }
  svg {
    background-color: ${colors.lightGray};
    color: ${colors.navyGray};
  }
`;

export const TermsAndConditionsWrapper = styled.label`
  display: flex;
  align-items: center;
  color: ${colors.darkBlue};
  line-height: 1.57;
  font-size: 14px;
  ${mt(1)}
  ${mb(2)}
`;

export const StyledRadioGroup = styled.div`
  display: flex;
  justify-content: space-between;
  width: 30%;
  font-weight: 600;
  line-height: 1.57;
  color: ${props => (props.treatmentFormName ? colors.white : colors.darkblue)};
  .styles__StyledDotOuter-sc-5wnwlz-3.hwEvAB {
    background-color: ${props => (props.treatmentFormName ? colors.white : colors.lightGray)};
    border: 1px solid ${colors.translucentDarkBlue};
    box-sizing: content-box !important;
  }
  .styles__StyledDotInner-sc-5wnwlz-4.jntRSA {
    background-color: ${props => (props.treatmentFormName ? '#075175' : colors.turquoise)};
    width: 100% !important;
    height: 100% !important;
    top: 1px !important;
    left: 1px !important;
    align-self: center !important;
  }
`;

export const StyledTextArea = styled.textarea`
  resize: none;
  margin-top: 8px;
  outline: none;
  border: 1px solid ${colors.translucentDarkBlue};
  font-size: 16px;
  ${p(2)}
  font-weight: 400;
  background-color: ${colors.lightGray};
  border-radius: 6px;
  ::placeholder {
    font-size: 16px;
  }
  ${breakpoint('mobile', 'tablet')`
    border-radius: 10px;
    ::placeholder {
    font-size: 12px;
    }
  `}
`;

export const StyledtextGridUnit = styled(Grid.Unit)`
  ${props => props.treatmentFormName && px(0)}
  ${props =>
    props.treatmentFormName
    && `
     textarea{
      background-color: ${colors.white};
      height: 60px;
      border: none;
     }
  `}
`;

export const StyledSelectContainer = styled.div`
  position: relative;
  width: 100%;
  ${mt(2)}
  select {
    background: ${colors.greyBlue10};
    appearance: none;
    border: none;
    border-radius: 0;
    width: 100%;
    font-size: 1rem;
    ${p(2.5)}
    ${breakpoint('desktop')`
      ${theme.borderRadius.small};
      background: ${colors.white};
    `}
  }
  &:before {
    margin: 0 5px;
    display: inline-block;
    border-top: 6px solid ${colors.darkBlue};
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    position: absolute;
    top: 20px;
    right: 10px;
    content: '';
    pointer-events: none;
  }
`;

export const PhoneWrapper = styled.div`
  input[type='tel'] {
    background-color: ${colors.white} !important;
    ${breakpoint('desktop')`
      ${({ greyBlue }) => !greyBlue && `background-color: ${colors.white} !important;`}
    `}
  }
`;

export const StyledLabelTextWrapper = styled.div`
  ${breakpoint('desktop')`
    color: ${props => (props.treatmentFormName ? colors.white : colors.darkBlue)};
    width: ${props => (props.treatmentFormName ? '100%' : '70%')} ;
  `}
  ${breakpoint('mobile', 'desktop')`
  color: ${props => (props.treatmentFormName ? colors.white : colors.darkBlue)};
  `}
`;

export const StyledLink = styled.a`
  color: ${theme.colors.navyGray};
`;

export const StyledValidationMessage = styled.div`

    padding-top:5px;
    font-size: 13px;
    color: #ffaebe;
`;
